var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationPin1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C5.27231 0 2.25 3.02231 2.25 6.75C2.25 8.21784 2.73122 9.56475 3.53109 10.6678C3.54544 10.6943 3.54769 10.7238 3.564 10.7491L8.064 17.4991C8.27269 17.8121 8.62425 18 9 18C9.37575 18 9.72731 17.8121 9.936 17.4991L14.436 10.7491C14.4526 10.7238 14.4546 10.6943 14.4689 10.6678C15.2688 9.56475 15.75 8.21784 15.75 6.75C15.75 3.02231 12.7277 0 9 0ZM9 9C7.75744 9 6.75 7.99256 6.75 6.75C6.75 5.50744 7.75744 4.5 9 4.5C10.2426 4.5 11.25 5.50744 11.25 6.75C11.25 7.99256 10.2426 9 9 9Z",
    fill: "#40356F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin1);
export default __webpack_public_path__ + "static/media/location-pin 1.eaafed3973b55a44952aaa42e4e16038.svg";
export { ForwardRef as ReactComponent };